export const arrayToObject = (arr) => {
  return arr.reduce((prev, curr) => {
    prev[curr] = true;
    return prev;
  }, {});
};
